import React, { useEffect, useState } from 'react'
import { GET } from '../../../utils/apicalls'
import { API } from '../../../config/api'
import { Button, Rate } from 'antd'
import { ShareAltOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import EnrollModal from '../../booking-payment/enrollmentModel'
import loading from '../../../assets/loading.gif'

function CourseDisplayCard() {

    const [allCourseData, setallCourseData] = useState<any>([]);
    const [searchQuery, setSearchQuery] = useState("");

    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
    const navigate = useNavigate(); // Initialize useNavigate hook for navigation
    const [selectedCourseForEnroll, setSelectedCourseForEnroll] = useState<string | number | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    // Update the showModal function
    const showModal = (courseId: string | number, e: React.MouseEvent) => {
        e.stopPropagation(); // Stop event propagation to prevent navigation
        setSelectedCourseForEnroll(courseId);
        setIsModalVisible(true);
    };

    // Update the handleCloseModal function
    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedCourseForEnroll(null); // Reset selected course when closing
    };


    const courses = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.GET_ALL_COURSES, {});
            setallCourseData(response?.data);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        courses();
    }, []);

    const filteredCourses = allCourseData.filter((course: any) => {
        const matchesCategory = selectedCategoryId ? course.category_id === selectedCategoryId : true;
        const matchesSearch = searchQuery ? course.course_title.toLowerCase().includes(searchQuery.toLowerCase()) : true;
        return matchesCategory && matchesSearch;

    });

    const handleViewDetails = (courseId: number) => {
        navigate(`/course/${courseId}`);
        window.scrollTo(0, 0); // Scroll to top after navigation
    };
    // function getRatingById(id: number): number {
    //     const ratings = [4.5, 4, 4.5, 5, 4.5]; // pre-defined rating values
    //     return ratings[id % ratings.length]; // pseudo-random assignment
    // }
    function getRatingById(id: number): number {
        return 5;
    }
    const shareOnWhatsApp = (course: any) => {
        const courseId = course?.id; // or course?.courseId depending on your data structure
        if (!courseId) {
            console.error("Course ID is undefined:", course);
            return;
        }

        const url = `https://meantoir.com/course/${courseId}`;
        const message = `Check out this course: ${course.course_title} - ${url}`;
        window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`, '_blank');
    };

    const orderedCourses = [...filteredCourses].sort((a: any, b: any) => {
        const getPriority = (title: string) => {
            title = title?.toLowerCase() || '';
            if (title.includes('enrolled agent')) return 0;
            if (title.includes('cfe')) return 1;
            if (title.includes('cfcs')) return 2;
            if (title.includes('cams')) return 3;
            if (title.includes('ctp')) return 4;
            if (title.includes('finance manager')) return 5;
            if (title.includes('finance specialist')) return 6;
            if (title.includes('ifrs')) return 7;
            return 8; // Lowest priority for all other courses
        };

        const aPriority = getPriority(a.course_title);
        const bPriority = getPriority(b.course_title);

        return aPriority - bPriority;
    });

    return (
        <div>
            {isLoading ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <img src={loading} alt="Loading..." style={{ width: '400px', height: '400px' }} />
                </div>

            ) : (
                <div>



                    <div className="courses-container">

                        <div className="normal-courses">
                            {orderedCourses.map((course: any) => {
                                const title = course.course_title?.toLowerCase();
                                const isEnrolledAgent = title.includes("enrolled agent");
                                const iscfe = title.includes("cfe");
                                const iscfcs = title.includes("cfcs");
                                const iscams = title.includes("cams");
                                const isctp = title.includes("ctp");
                                const isFinanceManager = title.includes("finance manager");
                                const isfinancespecialist = title.includes("finance specialist");
                                const isifrs = title.includes("ifrs");

                                // console.log("course titile", course.course_title?.toLowerCase());
                                return (
                                    <div key={course.id} onClick={() => handleViewDetails(course.id)}>

                                        <div className="image-container">
                                            <img src={course.course_image} alt={course.course_title} className="course-image" />

                                        </div>
                                        <div >
                                            <h2 style={{ textAlign: "center" }}>
                                                {course.course_title.replace(/\s*\(([^)]+)\)/, '\n($1)').split('\n').map((part: any, idx: any) => (
                                                    <React.Fragment key={idx}>
                                                        {part}
                                                        <br />
                                                    </React.Fragment>
                                                ))}
                                            </h2>
                                            {(isEnrolledAgent || iscfe || iscfcs || iscams || isctp || isFinanceManager || isfinancespecialist || isifrs) && (
                                                <div className="course-highlightss">
                                                    {isEnrolledAgent && (
                                                        <>
                                                            <p><strong>1 Book | 5–6 Months</strong></p>
                                                            <p>Earn up to <strong>10+ LPA</strong> in just 6 months!</p>
                                                            <p>Jobs at Big 4 & MNCs in India & Abroad</p>
                                                        </>
                                                    )}
                                                    {iscfe && (
                                                        <>
                                                            <p><strong>4 Exams | 3-4 Months </strong></p>
                                                            <p>Earn up to <strong>12+ LPA</strong> in just 4 months!</p>
                                                            <p>Jobs at Big 4, Banks, MNCs & Risk Consulting  <br /> <br />Firms </p>
                                                        </>
                                                    )}

                                                    {iscfcs && (
                                                        <>
                                                            <p><strong>3 Exams | 3-4 Months </strong></p>
                                                            <p>Earn up to <strong>12+ LPA</strong> in just 4 months!</p>
                                                            <p>Jobs at Big 4, Banks, MNCs & Risk Consulting Firms </p>
                                                        </>
                                                    )}
                                                    {iscams && (
                                                        <>
                                                            <p><strong>1 Exams | 3-4 Months </strong></p>
                                                            <p>Earn up to <strong>12+ LPA</strong> in just 4 months!</p>
                                                            <p>Jobs at Big 4, Global Banks, MNCs & FinTech Companies </p>
                                                        </>
                                                    )}
                                                    {isctp && (
                                                        <>
                                                            <p><strong>1 Exams | 3-4 Months </strong></p>
                                                            <p>Earn up to <strong>15+ LPA</strong> in just 4 months!</p>
                                                            <p>Jobs at Fortune 500 Companies, Big 4, Global Banks & MNCs</p>
                                                        </>
                                                    )}
                                                    {isFinanceManager && (
                                                        <>
                                                            <p><strong>1 Book | 2 Months</strong></p>
                                                            <p>Earn up to <strong>5 LPA</strong> in just 2 months!</p>
                                                            <p>Jobs at Big 4 & MNCs in India & Abroad</p>
                                                        </>
                                                    )}
                                                    {isfinancespecialist && (
                                                        <>
                                                            <p><strong>1 Book | 2 Months</strong></p>
                                                            <p>Earn up to <strong>5 LPA</strong> in just 2 months!</p>
                                                            <p>Jobs at Big 4 & MNCs in India & Abroad</p>
                                                        </>
                                                    )}
                                                    {isifrs && (
                                                        <>
                                                            <p><strong>1 Book | 2 Months</strong></p>
                                                            <p>Earn up to <strong>5 LPA</strong> in just 2 months!</p>
                                                            <p>Jobs at Big 4 & MNCs in India & Abroad</p>
                                                        </>
                                                    )}

                                                </div>
                                            )}
                                            <div style={{ marginBottom: '8px' }}>
                                                <Rate allowHalf disabled defaultValue={getRatingById(course.id)} />
                                                {/* <span>{getRatingById(course.id)} / 5</span> */}
                                            </div>
                                        </div>

                                        <div className="button-container" style={{ display: 'flex', alignItems: 'center', gap: '10px', }}>
                                            <Button
                                                className="courseCard-button primary-button"
                                                onClick={(e) => showModal(course.id, e)}
                                            >
                                                Enroll Now
                                            </Button>

                                            <Button className="courseCard-button primary-button" onClick={() => handleViewDetails(course.id)} style={{ color: "white" }}>
                                                View Details
                                            </Button>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    cursor: 'pointer',
                                                    color: 'red',
                                                    fontSize: '16px'
                                                }}
                                            // onClick={() => shareOnWhatsApp(filteredCourses)}
                                            >
                                                <ShareAltOutlined onClick={(e) => {
                                                    e.stopPropagation();
                                                    shareOnWhatsApp(course);
                                                }} style={{ fontSize: "24px", color: "red", marginRight: "6px" }} />

                                                {/* <span>Share</span> */}
                                            </div>

                                            {isModalVisible && (
                                                <EnrollModal
                                                    visible={isModalVisible}
                                                    onClose={handleCloseModal}
                                                    courseId={selectedCourseForEnroll}
                                                />
                                            )}
                                        </div>

                                    </div>
                                );
                            })}
                        </div>



                    </div>


                </div>
            )}
        </div>
    )
}

export default CourseDisplayCard
